import React from "react";
import { Reveal } from "@/components/site/ui";

export const QuestoesTransversais = ({ data }) => (
    <Reveal className="mt-16" >
        <div data-testid="disciplina-transversais">
            <p className="font-sans text-[10.5px] uppercase tracking-[0.28em] text-[#8a6a22]">Questões transversais</p>
            <p className="mt-3 max-w-3xl font-sans font-light text-[14px] leading-[1.8] text-[#2d3a31]">{data.lead}</p>
            <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-10">
                {data.itens.map((it) => (
                    <article key={it.id} data-testid={`transversal-${it.id}`} className="border-t-2 border-[#C7A659] pt-6">
                        <h3 className="font-serif font-light text-[22px] md:text-[24px] leading-[1.3]">{it.t}</h3>
                        <p className="mt-3 font-sans font-light text-[14px] leading-[1.8] text-[#2d3a31]">{it.d}</p>
                        {it.nota && <p data-testid={`transversal-${it.id}-nota`} className="mt-4 font-serif text-[16.5px] leading-[1.5] border-l-2 border-[#C7A659] pl-4">{it.nota}</p>}
                        <ul className="mt-5 flex flex-col">
                            {it.q.map((q) => (
                                <li key={q} className="py-3.5 border-t border-[#0E2018]/15 font-serif italic text-[17px] leading-[1.45]">{q}</li>
                            ))}
                        </ul>
                    </article>
                ))}
            </div>
        </div>
    </Reveal>
);
